import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers/transferReducer';
import networkReducer from '../reducers/networkReducer';
import assetReducer from '../reducers/assetReducer';

const store = configureStore({
  reducer: {
    transfer: rootReducer,
    network: networkReducer, // Define network slice and its reducer
    asset:assetReducer
  },
  // Optionally, you can pass other options such as middleware, devTools, etc.
});

export default store;
